export enum RegistrationType {
  Stocking = 'stocking',
  Transfer = 'transfer',
  Harvest = 'harvest',
  Feeding = 'feeding',
  Treatment = 'treatment',
  WaterQualitySample = 'waterQualitySample',
  MeanWeightSample = 'meanweightSample',
  Mortality = 'mortality',
  Feeders = 'feederChange',
  Aerators = 'aeratorChange',
}
